import { commonService } from '.';

const getListeRechercheMyCollab = (body) => {
    return commonService.getWithParam('ListMyConsultant/recherche', body);
};

const getListeEaImminent = (body) => {
    return commonService.getWithParam('ListMyConsultant/ea', body);
};

const getListeDcAValider = (body) => {
    return commonService.getWithParam('ListMyConsultant/dcAValider', body);
};

const getListeEaAValider = (body) => {
    return commonService.getWithParam('ListMyConsultant/eaAValider', body);
};

const updateEaEcheanceUser = (reference, dateEcheance, nextEaYear) => {
    return commonService.put('ListMyConsultant/updateEaEcheanceUser?reference=' + reference + '&dateEcheance=' + dateEcheance + '&nextEaYear=' + nextEaYear);
};

export const listeMyConsultantService = {
    getListeRechercheMyCollab,
    getListeEaImminent,
    getListeDcAValider,
    getListeEaAValider,
    updateEaEcheanceUser
};
